import { combineReducers } from 'redux';

import management from '../modules/management';
import uistate from '../modules/uistate';
import companies from '../modules/companies';
import currentuser from '../modules/currentuser';
import globalappstate from '../modules/globalappstate';
import userspicker from '../modules/core/pickers/users';
import reports from '../modules/reports';
import workflow from '../modules/workflow';
import incidents from '../modules/incidents';
import dossier from '../modules/dossier';
import processingactivities from '../modules/processingactivities';
import changelog from '../modules/changelog';
import KYC from '../modules/KYC';

const rootReducer = combineReducers({
  [uistate.constants.NAME]: uistate.reducer,
  [currentuser.constants.NAME]: currentuser.reducer,
  [globalappstate.constants.NAME]: globalappstate.reducer,
  [management.constants.NAME]: management.reducer,
  [companies.constants.NAME]: companies.reducer,
  [userspicker.constants.NAME]: userspicker.reducer,
  [reports.constants.NAME]: reports.reducer,
  [workflow.constants.NAME]: workflow.reducer,
  [incidents.constants.NAME]: incidents.reducer,
  [dossier.constants.NAME]: dossier.reducer,
  [processingactivities.constants.NAME]: processingactivities.reducer,
  [changelog.constants.NAME]: changelog.reducer,
  [KYC.constants.NAME]: KYC.reducer,
 });

export default rootReducer;